import React, { useState } from "react";
import homeImg from "../../../assets/images/HomeImg.webp";
import sectionBg from "../../../assets/images/HomeBg.webp";
import sectionBgV from "../../../assets/images/HomeBg-Vertical.webp";
import iconCopy from "../../../assets/icons/copy-svgrepo-com.svg";
import iconCopied from "../../../assets/icons/copy-success-svgrepo-com.svg";
import { Container, BannerBg, VideoBg } from "./styles";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Video from "../../../videos/logo.webm";
import Flip from "../../Flip";

const FirstSection = () => {
  const [isCopied, setIsCopied] = useState(false);
  const contractNumber = "0x970732E96DdE400975BfdF8C356d9CBdcfB84B29";

  return (
    <Container id="home" className="dc-section">
      <img src={sectionBg} alt="" className="dc-background-img desktop" width="1248px"/>
      <img src={sectionBgV} alt="" className="dc-background-img mobile" />
      <div className="container">
        <>
          <CopyToClipboard
            text={contractNumber}
            onCopy={() => {
              alert("Copied");
              setIsCopied(true);
            }}
          >
            <span className="dc-title dc-contract dc-contract--desktop">
              Contract: {contractNumber}
              {isCopied ? (
                <img src={iconCopied} alt="copied" />
              ) : (
                <img src={iconCopy} alt="copy" />
              )}
            </span>
          </CopyToClipboard>

          <CopyToClipboard
            text={contractNumber}
            onCopy={() => {
              alert("Copied");
              setIsCopied(true);
            }}
          >
            <span className="dc-title dc-contract dc-contract--mobile">
              Copy Contract
              {isCopied ? (
                <img src={iconCopied} alt="copied" />
              ) : (
                <img src={iconCopy} alt="copy" />
              )}
            </span>
          </CopyToClipboard>
        </>
        <h2 className="dc-title dc-home-title">$GROK</h2>
        <p className="dc-text dc-home-text">
        Grok Christmas, a meme cherished by many, is poised to ascend among the top 80 cryptocurrencies worldwide. With its captivating charm, it has cultivated a devoted following. Now, Grok Christmas aims to surpass Grok market capitalization and make an impact in the crypto world. Join the journey of this meme revolution!
        </p>
        <div className="home_btn">
          <a
            href="#"
            className="btn_one wow bounceIn"
            target="_blank"
            data-wow-delay=".6s"
          >
            Buy Coin
          </a>
          {/* <a
                  href=""
                  className="btn_two wow bounceIn"
                  target="_blank"
                  data-wow-delay=".8s"
                >
                  
                </a> */}
        </div>
      </div>
      <img src={homeImg} className="hero-text-img" alt="" />
      {/* <Flip /> */}
      {/* <BannerBg>
                <VideoBg autoPlay loop muted src={Video} />
              </BannerBg> */}
      {/* <video style="width: 100%;" autoplay muted loop id="myVideo">
                <source src="assets/video/" type="video/webm"> 
              </video>  */}
    </Container>
  );
};

export default FirstSection;
